export default __webpack_public_path__ + "static/media/MuteCh1On.de4072c2.svg";